import { CoreExecutorResult, } from "../../core/index.js";
import { DataPsmCreateOrResult, } from "../operation/index.js";
import { DataPsmExecutorResultFactory, loadDataPsmSchema, } from "./data-psm-executor-utils.js";
import { DataPsmOr } from "../model/index.js";
export async function executeDataPsmCreateOr(reader, createNewIdentifier, operation) {
    const schema = await loadDataPsmSchema(reader);
    if (schema === null) {
        return DataPsmExecutorResultFactory.missingSchema();
    }
    const iri = operation.dataPsmNewIri ?? createNewIdentifier("or");
    const result = new DataPsmOr(iri);
    return CoreExecutorResult.createSuccess([result], [
        {
            ...schema,
            dataPsmParts: [...schema.dataPsmParts, iri],
        },
    ], [], new DataPsmCreateOrResult(iri));
}
//# sourceMappingURL=data-psm-create-or-executor.js.map